import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import image from '../../../img/other/graph_participation_congrats.png';
import logo from '../../../img/logo/logo_light.svg';
import { isMobile } from 'react-device-detect';

const styles = theme => ({
  root: {
    display: 'flex', 
    justifyContent: 'space-around', 
    alignItems: 'stretch', 
    flexFlow: 'column wrap'
  },
  item: {
    flexBasis: 'initial',
    flexGrow: 1,
    display: 'inline-flex'
  },
  buttonIndigo: theme.custom.button.indigo,
  continue: {
    flexGrow: 1, 
    alignItems: 'flex-end', 
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      alignItems: 'flex-start', 
      flexGrow: 5
    },
  },
  fantastico: {
    flexGrow: 1, 
    alignItems: 'center', 
    flexFlow: 'column', 
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      flexGrow: 5,
      justifyContent: 'flex-end',
    },
  },
  imageContainer: {
    flexGrow: 1, 
    alignItems: 'flex-end', 
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      alignItems: 'center', 
    },
  },
  infoContainer: {
    flexGrow: 2, 
    alignItems: 'flex-end', 
    justifyContent: 'center',
    flexFlow: 'column',
    [theme.breakpoints.up('sm')]: {
      flexGrow: 1, 
      alignItems: 'center', 
    },
  },
})

class AccountCreated extends React.PureComponent {

  render() {
    const { email, classes, accountType } = this.props;
    return (
      <main>
        <Grid container className={classes.root} spacing={8} alignItems="center">

          <Grid item xs={12} className={classes.item} style={{flexGrow: 1, justifyContent: 'center'}}>
            {isMobile && <img src={logo} style={{maxHeight: 36}} />}
          </Grid>

          <Grid item xs={12} className={classNames(classes.item, classes.fantastico)}>
            <Typography component='div' variant='headline'>
              ¡Fantástico!
            </Typography>
            <Typography component="div" variant="subheading">
              Tu cuenta ha sido creada
            </Typography>
          </Grid>
          <Grid item xs={12} className={classNames(classes.item, classes.imageContainer)}>
            <img src={image} />
          </Grid>
          {accountType === 'v' && 
          <React.Fragment>
            <Grid item xs={12} className={classNames(classes.item, classes.infoContainer)}>
              <Typography align="center">
              Te hemos enviado un email a <strong>{email}</strong> para confirmar que tu formulario se ha enviado correctamente.
              </Typography>
            </Grid>
            <Grid item xs={12} className={classNames(classes.item, classes.continue)}>
              <Button type="submit" variant="contained" className={classes.buttonIndigo} component={Link} to="/account/home">
                Siguiente
              </Button>
            </Grid>
          </React.Fragment>
          }
          {accountType === 'c' && 
          <React.Fragment>
            <Grid item xs={12} className={classNames(classes.item, classes.infoContainer)}>
              <Typography align="center">
                Te hemos enviado un email a <strong>{email}</strong> para confirmar que tu formulario se ha enviado correctamente.
              </Typography>
              <Typography align="center">
                En los próximos días CosmoCare revisará tu perfil y te comunicará si has entrado en nuestra base de consumidores.
              </Typography>
            </Grid>
            <Grid item xs={12} className={classNames(classes.item, classes.continue)}>
              <Button type="submit" variant="contained" className={classes.buttonIndigo} component={Link} to="/account/home">
                Siguiente
              </Button>
            </Grid>
          </React.Fragment>
          }

        </Grid>
      </main>
    )
  }
}

export default withStyles(styles)(AccountCreated);


// WEBPACK FOOTER //
// ./src/modules/register/pages/AccountCreated.js